<template>
  <div>
    <div style="display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    justify-content: flex-start;">
      <div v-for="item in tableColumn" :key="item.id">
        <Y-select v-if="item.dicDataItems && item.dicDataItems.length" style="width: 160px;margin-right: 10px;"
                  :value.sync="filter[item.fieldName]" :options="item.dicDataItems"
                  :placeholder="item.showName" filterType="input"></Y-select>
        <el-input size="mini" v-model="filter[item.fieldName]" :placeholder="item.showName" style="width: 160px;margin-right: 10px;"
          @keyup.enter.native="handleSearch" v-else-if="item.dataType != null && (item.dataType == 1 || item.dataType == 5)"></el-input>
        <el-date-picker
          v-else-if="item.dataType != null && item.dataType == 3"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :start-placeholder="item.showName+'起'"
          :end-placeholder="item.showName+'终'"
          v-model="filter[item.fieldName]"
          size="mini"
          style="height: 100%;"
          @keyup.enter.native="handleSearch">
        </el-date-picker>
      </div>
      <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
    </div>
    <el-table
      :data="tableData"
      :max-height="maxHeight"
      ref="Ytable"
      border
      size="mini"
      class="radioTable"
      @cell-click="roadeChange"
      @cell-dblclick="dbRoadeChange"
      :highlight-current-row="true"
    >
      <el-table-column
        label="单选"
        width="60"
        align="center"
        header-align="center"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-radio class="radio" v-model="radio" :label="scope.row.id" @change="roadeChange(scope.row)">
            <span></span>
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('configMoudle.linenum')"
        type="index"
        width="60"
        align="center"
        fixed="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :prop="item.fieldName"
        :label="item.showName"
        sortable
        :min-width="item.width === 'auto' ? '' : item.width || item.colWidth || 120"
        :show-overflow-tooltip="item.fieldName != 'img_ids'"
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px">
            {{
              item.dataType == 2 || item.dataType == 4 ? parseToThousandth(scope.row[item.fieldName], item.decimalDigit) : scope.row[item.fieldName]
            }}
            <!-- {{ scope.row[item.fieldName] | booleanFilter(item, fieldsVOs) }} -->
            </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import clone from "clone"
export default {
  name: "Y-radioTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [String, Number]
    },
    column: {
      type: Array,
      default: () => [],
    },
    fieldsVOs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      radio: '',
      tableColumn: [],
      filter: {}
    };
  },
  computed: {
    columnList(){
      return this.column.filter(item=>{
        return (item.hasOwnProperty('isShow') && item.isShow && item.showName !== "" && item.showName !== null && item.showName !== undefined) || !item.hasOwnProperty('isShow');
      })
    }
  },
  created() {
    // this.tableColumn = []
    // this.tableColumn = this.column.filter(function (item) {
    //   return item.isShow
    // })
  },
  watch: {
    tableData: {
      handler(newVal) {
      },
      deep: true,
      immediate: true,
    },
    column: {
      handler(val) {
        this.tableColumn = []
        this.tableColumn = val.filter(function (item) {
          return item.isShow && item.isFilter
        })
      }, deep: true, immediate: true
    }
  },
  mounted() {
  },
  methods: {
    parseToThousandth(num, point) {
      let newnum = ""
      if (num === "" || num === undefined || num === null) {
        newnum = ""
      } else {
        newnum = num + ""
      }
      if (point && point != 0) {
        let [sInt, sFloat] = (Number.isInteger(newnum) ? `${newnum}` : Number(newnum)?.toFixed(point) + "").split('.');
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, '$&,');
        return sFloat ? `${sInt}.${sFloat}` : `${sInt}`;
      } else {
        let [sInt, sFloat] = (Number.isInteger(newnum) ? `${newnum}` : newnum).split('.');
        sInt = sInt.replace(/\d(?=(\d{3})+$)/g, '$&,');
        return sFloat ? `${sInt}.${sFloat}` : `${sInt}`;
      }
    },
    roadeChange (row) {
      this.$emit("roadeChange", row)
    },
    dbRoadeChange (row) {
      this.$emit("roadeChange", row)
      this.$emit('bindOkVendor')
    },
    handleSearch() {
      this.$emit("handleSearch", this.filter)
    }
  },
  components: {},
  destroyed() {
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-table th, .el-table th.is-leaf {
  background: rgb(218, 219, 221)!important;
}
/deep/ .radioTable td div {
  height: auto;
}
</style>
